var _path, _path2, _line, _line2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5966 6.0713C12.6201 6.07431 12.6439 6.07431 12.6675 6.0713H17.0341L12.3342 1.07129V5.71412C12.3145 5.89049 12.432 6.05038 12.5966 6.0713Z",
    fill: "#5650FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.49999C11.7462 7.49999 11 6.70052 11 5.7143V0H2C0.895396 0 0 0.959425 0 2.14286V22.8571C0 24.0406 0.895396 25 2 25H16C17.1045 25 18 24.0406 18 22.8571V7.49999H12.6667ZM14.6666 17.6429C14.6666 18.0374 14.3681 18.3572 13.9999 18.3572C13.6317 18.3572 13.3333 18.0374 13.3333 17.6429V15.3215L10.4666 18.7857C10.3435 18.9203 10.1758 18.9973 9.99994 19C9.82703 19.0204 9.65502 18.9546 9.53329 18.8215L6.73327 16.0714L4.39997 19.5714C4.21763 19.8913 3.82786 19.9922 3.5294 19.7968C3.50764 19.7826 3.48671 19.767 3.46668 19.75C3.17593 19.5417 3.09784 19.1203 3.29224 18.8088C3.30494 18.7884 3.31866 18.7688 3.33333 18.75L6.09998 14.6072C6.19613 14.4288 6.37439 14.3196 6.56662 14.3214C6.7491 14.3048 6.92991 14.3694 7.06664 14.5L9.93332 17.3571L12.5333 14.2857H10.1C9.73178 14.2857 9.43331 13.9659 9.43331 13.5714C9.43331 13.1769 9.73178 12.8571 10.1 12.8571H14C14.3667 12.8571 14.6667 13.0357 14.6667 13.4285L14.6666 17.6429Z",
    fill: "#5650FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 6.4,
    x2: 7.4,
    y2: 6.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 9.49717,
    x2: 9.4,
    y2: 9.49717,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 13,
    height: 11,
    fill: "#5650FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6362 12.5083H11.6201C11.4853 12.5083 11.3561 12.5618 11.2608 12.6571C11.1656 12.7524 11.112 12.8816 11.112 13.0163V21.6489H13.1442V13.0163C13.1442 12.8816 13.0907 12.7524 12.9954 12.6571C12.9001 12.5618 12.7709 12.5083 12.6362 12.5083ZM9.58794 15.5565H8.57187C8.43713 15.5565 8.30791 15.61 8.21264 15.7053C8.11736 15.8006 8.06384 15.9298 8.06384 16.0645V21.6489H10.096V16.0645C10.096 15.9298 10.0425 15.8006 9.94718 15.7053C9.8519 15.61 9.72268 15.5565 9.58794 15.5565ZM6.53973 18.6047H5.52366C5.38892 18.6047 5.2597 18.6582 5.16443 18.7535C5.06915 18.8488 5.01563 18.978 5.01562 19.1128V21.6489H7.04777V19.1128C7.04777 18.978 6.99424 18.8488 6.89897 18.7535C6.80369 18.6582 6.67447 18.6047 6.53973 18.6047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestReport);
export default __webpack_public_path__ + "static/media/testReport.eb67e73347c170d79f93ebd39723bca3.svg";
export { ForwardRef as ReactComponent };